import React from 'react';
import { RequiredLabel } from './RequiredLabel';

export const AppInputWrapper = ({ labelFontSize, customClass, required, requiredError, label, color, children }) =>  {
   return (
       <div className={`result-input ${customClass || ''}`}>
           <div className="text-label inner-margin" style={{ color }}>
               {
                   label &&
                   <div className="input-label-wrapper">
                       <span
                           className={`input-label-text ${!required ? 'full-width' : ''}`}
                       >{ label }</span>
                       { required && <RequiredLabel error={requiredError} color={color} /> }
                   </div>
               }

               { children }
           </div>
       </div>
   )
};
